import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../services';
import {
  getQueryStringFromObject,
  ProofOfDeliveryDownloadFileParams,
  ProofOfDeliverySaveParams,
} from '../../../../common';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { RequestHeader } from '../../../constants';
import { PublicProofOfDeliveryEndpoint } from './constants/public-proof-of-delivery-endpoint';
import { PublicProofOfDeliveryItem } from './models/public-proof-of-delivery.model';

@Injectable({
  providedIn: 'root',
})
export class PublicProofOfDeliveryService {
  constructor(private http: WrapperHttpService) {}

  getPublicProofOfDeliveryItem(token: string): Observable<PublicProofOfDeliveryItem> {
    return this.http.withLoading().get<PublicProofOfDeliveryItem>(
      `${API_URL}${PublicProofOfDeliveryEndpoint.Base}${PublicProofOfDeliveryEndpoint.Monitoring}${
        PublicProofOfDeliveryEndpoint.DeliveryNote
      }${PublicProofOfDeliveryEndpoint.ProofOfDelivery}${
        PublicProofOfDeliveryEndpoint.Public
      }?${getQueryStringFromObject({
        token,
      })}`,
      {
        headers: new HttpHeaders({
          [RequestHeader.SkipInterceptor]: '',
        }),
      },
    );
  }
  downloadFile({ token, documentId }: ProofOfDeliveryDownloadFileParams): Observable<HttpResponse<Blob>> {
    const url = `${API_URL}${PublicProofOfDeliveryEndpoint.Base}${PublicProofOfDeliveryEndpoint.Monitoring}${
      PublicProofOfDeliveryEndpoint.DeliveryNote
    }${PublicProofOfDeliveryEndpoint.ProofOfDelivery}${PublicProofOfDeliveryEndpoint.Public}${
      PublicProofOfDeliveryEndpoint.Documents
    }/${documentId}?${getQueryStringFromObject({
      token,
    })}`;
    return this.http.get<HttpResponse<Blob>>(url, {
      headers: new HttpHeaders({
        [RequestHeader.SkipInterceptor]: '',
      }),
      responseType: 'blob',
      observe: 'response',
    });
  }

  savePublicProofOfDeliveryItem({
    token,
    proofOfDeliveryItemValue,
  }: ProofOfDeliverySaveParams): Observable<PublicProofOfDeliveryItem> {
    return this.http.withLoading().post<PublicProofOfDeliveryItem>(
      `${API_URL}${PublicProofOfDeliveryEndpoint.Base}${PublicProofOfDeliveryEndpoint.Monitoring}${
        PublicProofOfDeliveryEndpoint.DeliveryNote
      }${PublicProofOfDeliveryEndpoint.ProofOfDelivery}${
        PublicProofOfDeliveryEndpoint.Public
      }?${getQueryStringFromObject({
        token,
      })}`,
      proofOfDeliveryItemValue,
      {
        headers: new HttpHeaders({
          [RequestHeader.SkipInterceptor]: '',
        }),
      },
    );
  }

  sendPublicProofOfDeliveryFeedback({ token, data }: { token: string; data: { text: string } }): Observable<string> {
    return this.http.withLoading().post<string>(
      `${API_URL}${PublicProofOfDeliveryEndpoint.Base}${PublicProofOfDeliveryEndpoint.Monitoring}${
        PublicProofOfDeliveryEndpoint.DeliveryNote
      }${PublicProofOfDeliveryEndpoint.ProofOfDelivery}${PublicProofOfDeliveryEndpoint.Public}${
        PublicProofOfDeliveryEndpoint.Documents
      }${PublicProofOfDeliveryEndpoint.Feedback}?${getQueryStringFromObject({
        token,
      })}`,
      data,
      {
        headers: new HttpHeaders({
          [RequestHeader.SkipInterceptor]: '',
        }),
      },
    );
  }
}
